import React from 'react';
import PropTypes from 'prop-types';
import SEO from '../molecules/SEO';
import InlineLogo from '../../assets/logo.inline.svg';
import {graphql, Link, StaticQuery} from 'gatsby';
import LargeImage from '../molecules/LargeImage';

import styled from 'styled-components';
import Video from '../molecules/Video';
import TwoColumn from '../molecules/TwoColumn';
import Column from '../molecules/Column';
import CircleText from '../atoms/CircleText';
import RichTextConverter from '../atoms/RichTextConverter';
import WalterLogo from '../../assets/walter-logo.inline.svg';
import BlogPreviews from '../molecules/BlogPreviews';
import GatsbyImage from "gatsby-image";

const HeroText = styled.div`
  color: ${props => props.theme.colours.white};
  text-align: center;
  > :first-child { margin-top: 0; }
  > :last-child { margin-bottom: 0; }
  svg {
    width: 10rem;
    height: auto;
    margin-bottom: 0.5rem;
    @media(${props => props.theme.breakpoints.md}) {
      width: 20rem;
    }
    path { fill: ${props => props.theme.colours.white}; }
  }
  a { margin-top: 1rem; }
`;

const WalterLogoHolder = styled.p`
  margin: -2rem 0 0 0;
  svg {
    width: 16rem;
    height: auto;
    display: block;
    margin-top: 3rem;
  }
`;

function PageContent( { data } ) {
  return (
    <>
      <SEO title={data.title}/>
      {data.heroImage && data.title === 'Home' && <LargeImage fluid={data.heroImage.fluid}>
        <HeroText>
          <InlineLogo/>
          <StaticQuery
            query={graphql`
              query PageContentQuery {
                contentfulGlobalSettings {
                  homepageHeroStrapline
                }
              }
            `}
            render={data => <p>{data.contentfulGlobalSettings.homepageHeroStrapline}</p>}
          />
          <p><Link to="/enquire" className="button inverse">Enquire now</Link></p>
        </HeroText>
      </LargeImage>}
      {data.heroImage && data.title !== 'Home' && <LargeImage fluid={data.heroImage.fluid}/>}

      {data.optionalVideo && <Video url={data.optionalVideo.file.url}/>}

      {data.modules.map( module => (
        <TwoColumn key={module.id} colour={module.backgroundColour}>
          <Column width={module.gridColumns.col1Width} hasPadding={module.hasPadding === 'Column 1'}>
            <RichTextConverter content={module.column1}/>
            {module.cta && module.cta.column === 1 && <p className="cta-holder">
              <Link to={module.cta.url} className="button">{module.cta.text}</Link></p>}
            {module.badge && module.badge.column === 1 &&
            <CircleText text={module.badge.text} length={180} top={module.badge.topPos} left={module.badge.leftPos}/>}
          </Column>
          <Column width={module.gridColumns.col2Width} hasPadding={module.hasPadding === 'Column 2'}>
            <RichTextConverter content={module.column2}/>
            {module.title === 'About 2' && <WalterLogoHolder><WalterLogo/></WalterLogoHolder>}
            {module.cta && module.cta.column === 2 && <p className="cta-holder">
              <Link to={module.cta.url} className="button">{module.cta.text}</Link></p>}
            {module.badge && module.badge.column === 2 &&
            <CircleText text={module.badge.text} length={180} top={module.badge.topPos} left={module.badge.leftPos}/>}
          </Column>
        </TwoColumn>
      ) )}

      {data.title === 'The Restaurant' && <BlogPreviews/>}


    </>
  )
}

PageContent.propTypes = {
  data: PropTypes.object
};

export default PageContent;
